module.exports = __webpack_public_path__ + "media/images/young_pin_design_award-s-0a76c394aac1f7672ce8688cd18d6121.png";